
export type Survy = {
    id:string,
    title:string,
    introduction:string,
    questions:{
        label:string,
        question:BasicSurvyQuestion
    }[]
}

export type BasicSurvyQuestion = {
    type:'basic',
    text:string,
    helpText:string,
    options:RatedQuestionValue[],
    ratingThresholds?:{
        neutralPct:number,
        goodPct:number
    }
}

export type RatedQuestionValue = {
    text:string,
    value:string,
    ratingPct: number | undefined
}

export const SurvyPracticeQuestionThresholds = {
    neutralPct: 70,
    goodPct: 90
} as const;

export const SurvyPracticeQuestionValues:RatedQuestionValue[] = [
    {
        text: 'Ikke implementeret',
        value: 'not-implemented',
        ratingPct: 0
    },
    {
        text: 'Delvist implementeret',
        value: 'partially-implemented',
        ratingPct: 50
    },
    {
        text: 'Implementeret',
        value: 'implemented',
        ratingPct: 70
    },
    {
        text: 'Implementeret og integreret i arbejdsmiljøarbejdet',
        value: 'implemented-and-itegrated',
        ratingPct: 90
    },
    {
        text: 'Best practice',
        value: 'best-practice',
        ratingPct: 100
    }
] as const;